import React, { useState, useEffect } from "react";
import {
  ThinTextField,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import { toast } from "react-toastify";
import { fetchData } from "../../utils/functions";
import * as Yup from "yup";
import Select from 'react-select';
import { useNavigate, useParams } from "react-router-dom"

const InfrastructureEnvironment = ({
  healthInfrastructure,
  isDqaApproved = false,
  onUpdate,
}) => {
  const [formData, setFormData] = useState({
    building_condition: "",
    repair_cost_estimate: "",
    boundary_wall: "",
    boundary_wall_repair: "",
    boundary_wall_cost: "",
    structure_type: "",
    total_rooms: "",
    consulting_rooms: "",
    wards: "",
    delivery_room: "",
    beds_total: "",
    power_supply: "",
    water_source: "",
    functional_latrines_total: "",
    functional_latrines_male: "",
    functional_latrines_female: "",
    functional_latrines_repair: "",
    functional_latrines_repair_cost: "",
    nonfunctional_latrines_total: "",
    nonfunctional_latrines_male: "",
    nonfunctional_latrines_female: "",
    nonfunctional_latrines_repair: "",
    nonfunctional_latrines_repair_cost: "",
    handwashing_station: "",
    handwashing_station_total: "",
    handwashing_station_repair: "",
    handwashing_station_repair_cost: "",
    // waste_disposal: "",
    // waste_disposal_area: "",
    water_storage_type: "",
    specify_other_storage: "",
    year_round_water_availability: "",
    handwash_stations_status: "",
  });

  const [errors, setErrors] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
   const { id } = useParams();
      const navigate = useNavigate();
       const [isDqaApproved2, setIsDqaApproved] = useState(false);
       const [isDqaRejected, setIsDqaRejected] = useState(false);
        const [isFetching, setIsFetching] = useState(false);
        const [loader, setLoader] = useState(false);

       const fetchHealthFacilityAssessment = async () => {
          try {
            setLoader(true);
            setIsFetching(true);
      
            const response = await fetchData(
              `health-fetchById/${id}`,
              "GET",
              null,
              {},
              {},
              navigate
            );
      
            if (response?.data) {
              const isDqaApproved =
                response.data?.healthFacility.verified_from_dqa === 1 ||
                response.data?.healthFacility.verified_from_dqa === "1";
      
                const isDqaRejected = 
              response.data?.healthFacility.verified_from_dqa === 2 ||
              response.data?.healthFacility.verified_from_dqa === "2";
      
              setIsDqaApproved(isDqaApproved);
              setIsDqaRejected(isDqaRejected)
            }
          } catch (error) {
            console.error("Error fetching school data:", error);
            toast.error("Failed to load school data.");
          } finally {
            setLoader(false);
            setIsFetching(false);
          }
        };
      
        useEffect(() => {
          fetchHealthFacilityAssessment();
        }, [id]);

  //Yup schema for validation
  const validationSchema = Yup.object().shape({
    building_condition: Yup.string().required("Building Condition is required"),
    repair_cost_estimate: Yup.mixed()
    .test('is-valid-number', 'Cost must be a valid number', (value) => {
      if (!value || value === '') return true;
      return /^\d+$/.test(value);
    })
    .test('max-digits', 'Cost cannot exceed 7 digits', (value) => {
      if (!value || value === '') return true;
      return parseInt(value) <= 9999999; 
    })
    .nullable()
    .when("building_condition", {
      is: "Requires Minor Repairs",
      then: (schema) =>
        schema.required(
          "Repair cost is required when building requires repairs"
        ),
    }),

    boundary_wall: Yup.string()
      .oneOf(["Yes", "No"])
      .required("Boundary Wall status is required"),
    boundary_wall_repair: Yup.string().when("boundary_wall", {
      is: "Yes",
      then: (schema) =>
        schema.required("Boundary wall repair status is required"),
    }),
    boundary_wall_cost: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(9999999, "Value cannot exceed 7 digits")
      .nullable()
      .when("boundary_wall_repair", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Repair cost is required when boundary wall needs repair"
          ),
      }),

    structure_type: Yup.string().required("Structure Type is required"),

    total_rooms: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(999, "Total rooms cannot exceed 999")
      .required("Total rooms is required"),

    consulting_rooms: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(500, "Consulting rooms cannot exceed 500")
      .required("Consulting rooms is required"),

    wards: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(500, "Wards cannot exceed 500")
      .required("Wards is required"),

    delivery_room: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(500, "Delivery rooms cannot exceed 500")
      .required("Delivery rooms is required"),

    beds_total: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(500, "Beds cannot exceed 500")
      .required("Beds is required"),

    power_supply: Yup.array()
    .min(1, "At least one power supply option is required")
    .required("Power Supply is required"),
    water_source: Yup.string().required("Water Source is required"),

    // Functional Latrines
    functional_latrines_total: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(99, "Functional latrines cannot exceed 99")
      .required("Functional latrines total is required")
      .test(
        "sum-check",
        "Total must equal Male + Female count",
        function (value) {
          const male = parseInt(this.parent.functional_latrines_male) || 0;
          const female = parseInt(this.parent.functional_latrines_female) || 0;
          return value === male + female;
        }
      ),

    functional_latrines_male: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(
        Yup.ref("functional_latrines_total"),
        "Cannot exceed total functional latrines"
      )
      .required("Functional latrines male is required"),

    functional_latrines_female: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(
        Yup.ref("functional_latrines_total"),
        "Cannot exceed total functional latrines"
      )
      .required("Functional latrines female is required"),

    functional_latrines_repair: Yup.string().required(
      "Functional latrines repair status is required"
    ),
    functional_latrines_repair_cost: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(9999999, "Value cannot exceed 7 digits")
      .nullable()
      .when("functional_latrines_repair", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Repair cost is required when functional latrines need repair"
          ),
      }),
    nonfunctional_latrines_male: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(
        Yup.ref("nonfunctional_latrines_total"),
        "Cannot exceed total non-functional latrines"
      )
      .required("Non-functional latrines male is required"),

    nonfunctional_latrines_female: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(
        Yup.ref("nonfunctional_latrines_total"),
        "Cannot exceed total non-functional latrines"
      )
      .required("Non-functional latrines female is required"),

    nonfunctional_latrines_repair: Yup.string().required(
      "Non-functional latrines repair status is required"
    ),
    nonfunctional_latrines_repair_cost: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(9999999, "Value cannot exceed 7 digits")
      .nullable()
      .when("nonfunctional_latrines_repair", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Repair cost is required when non-functional latrines need repair"
          ),
      }),
    nonfunctional_latrines_total: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(99, "Non-functional latrines cannot exceed 99")
      .required("Non-functional latrines total is required")
      .test(
        "sum-check",
        "Total must equal Male + Female count",
        function (value) {
          const male = parseInt(this.parent.nonfunctional_latrines_male) || 0;
          const female =
            parseInt(this.parent.nonfunctional_latrines_female) || 0;
          return value === male + female;
        }
      ),

    // Handwashing Stations
    handwashing_station: Yup.string().required(
      "Handwashing Stations status is required"
    ),
    handwashing_station_total: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(150, "Handwashing stations cannot exceed 150")
      .nullable()
      .when("handwashing_station", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Handwashing stations total is required when available"
          ),
      }),

    handwashing_station_repair: Yup.string().when("handwashing_station", {
      is: "Yes",
      then: (schema) =>
        schema.required("Handwashing stations repair status is required"),
    }),

    handwashing_station_repair_cost: Yup.number()
      .transform((value) =>
        isNaN(value) || value === null || value === "" ? undefined : value
      )
      .min(0, "Value cannot be negative")
      .max(9999999, "Value cannot exceed 7 digits")
      .nullable()
      .when("handwashing_station_repair", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Repair cost is required when handwashing stations need repair"
          ),
      }),

    handwash_stations_status: Yup.string()
      .oneOf(
        ["Functional", "Non-Functional"],
        "Must be Functional or Non-Functional"
      )
      .when("handwashing_station", {
        is: "Yes",
        then: (schema) =>
          schema.required("Status is required when handwashing stations exist"),
      }),

    // Waste Disposal
    // waste_disposal: Yup.string().required("Medical Waste Disposal status is required"),
    // waste_disposal_area: Yup.string()
    //   .when("waste_disposal", {
    //     is: "Yes",
    //     then: (schema) => schema.required("Waste disposal area is required when medical waste disposal is available"),
    //   }),

    //  Water
    water_storage_type: Yup.string().required("Water Storage Type is required"),
    specify_other_storage: Yup.string().when("water_storage_type", {
      is: "Others",
      then: (schema) => schema.required("Please specify other storage"),
    }),

    year_round_water_availability: Yup.string().required(
      "Year Round Water Availability is required"
    ),
  });

  // Dropdown options
  const buildingConditions = [
    { label: "Good", value: "Good" },
    { label: "Requires Minor Repairs", value: "Requires Minor Repairs" },
    { label: "Unsafe", value: "Unsafe" },
  ];

  const yesNo = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const structureTypes = [
    { label: "RCC", value: "RCC" },
    { label: "Semi-Pacca", value: "Semi-Pacca" },
    { label: "Mud", value: "Mud" },
    { label: "Temporary", value: "Temporary" },
  ];

  const powerSupplies = [
    { label: "WAPDA", value: "WAPDA" },
    { label: "Solar", value: "Solar" },
    { label: "Generator", value: "Generator" },
  ];

  const waterSources = [
    { label: "Borehole", value: "Borehole" },
    { label: "Piped", value: "Piped" },
    { label: "Tanker", value: "Tanker" },
    { label: "None", value: "None" },
  ];

  // Populate formData from backend
  useEffect(() => {
    if (healthInfrastructure) {
      setFormData({
        building_condition: healthInfrastructure.building_condition || "",
        repair_cost_estimate: healthInfrastructure.repair_cost_estimate 
        ? healthInfrastructure.repair_cost_estimate.split('.')[0] 
        : "",
        boundary_wall: healthInfrastructure.boundary_wall ? "Yes" : "No",
        boundary_wall_repair:
          healthInfrastructure.boundary_repair_needed === true
            ? "Yes"
            : healthInfrastructure.boundary_repair_needed === false
            ? "No"
            : "",
        boundary_wall_cost: healthInfrastructure.boundary_repair_cost 
      ? healthInfrastructure.boundary_repair_cost.split('.')[0] 
      : "",
        structure_type: healthInfrastructure.health_building_structure || "",
        total_rooms: healthInfrastructure.total_number_of_rooms || "",
        consulting_rooms: healthInfrastructure.number_of_consulting_rooms || "",
        wards: healthInfrastructure.number_of_wards_rooms || "",
        delivery_room: healthInfrastructure.number_of_delivery_rooms || "",
        beds_total: healthInfrastructure.number_of_beds || "",
        power_supply: healthInfrastructure.power_supply 
        ? (Array.isArray(healthInfrastructure.power_supply) 
            ? healthInfrastructure.power_supply 
            : healthInfrastructure.power_supply.split(',').map(item => item.trim()))
        : [],
        water_source: healthInfrastructure.water_source || "",
        functional_latrines_total:
          healthInfrastructure.functional_latrines_total || "",
        functional_latrines_male:
          healthInfrastructure.functional_latrines_male || "",
        functional_latrines_female:
          healthInfrastructure.functional_latrines_female || "",
        functional_latrines_repair:
          healthInfrastructure.functional_latrines_repair ? "Yes" : "No",
        functional_latrines_repair_cost:
          healthInfrastructure.functional_repair_cost || "",
        nonfunctional_latrines_total:
          healthInfrastructure.non_functional_latrines_total || "",
        nonfunctional_latrines_male:
          healthInfrastructure.non_functional_latrines_male || "",
        nonfunctional_latrines_female:
          healthInfrastructure.non_functional_latrines_female || "",
        nonfunctional_latrines_repair:
          healthInfrastructure.non_functional_latrines_repair ? "Yes" : "No",
        nonfunctional_latrines_repair_cost:
          healthInfrastructure.non_functional_repair_cost || "",
        handwashing_station: healthInfrastructure.handwashing_stations_available
          ? "Yes"
          : "No",
        handwashing_station_total:
          healthInfrastructure.handwashing_stations_count || "",
        handwashing_station_repair: healthInfrastructure.handwashing_repairable
          ? "Yes"
          : "No",
        handwashing_station_repair_cost:
          healthInfrastructure.handwashing_repair_cost || "",
        // waste_disposal: healthInfrastructure.medical_waste_disposal ? "Yes" : "No",
        // waste_disposal_area: healthInfrastructure.waste_disposal_location || "",
        water_storage_type: healthInfrastructure.water_storage_type || "",
        specify_other_storage: healthInfrastructure.specify_other_storage || "",
        year_round_water_availability:
          healthInfrastructure.year_round_water_availability === true
            ? "Yes"
            : healthInfrastructure.year_round_water_availability === false
            ? "No"
            : "",
        handwash_stations_status:
          healthInfrastructure.handwash_stations_status || "",
        // waste_disposal_area: healthInfrastructure.waste_disposal_location || "",
      });
    }
  }, [healthInfrastructure]);

  // Reset dependent fields when conditions change
  useEffect(() => {
    if (formData.building_condition) {
      if (formData.building_condition !== "Requires Minor Repairs") {
        setFormData((prev) => ({ ...prev, repair_cost_estimate: "" }));
      }
    }
  }, [formData.building_condition]);

  useEffect(() => {
    if (formData.boundary_wall !== "Yes") {
      setFormData((prev) => ({
        ...prev,
        // boundary_wall_repair: "",
        // boundary_wall_cost: ""
      }));
    } else if (formData.boundary_wall_repair !== "Yes") {
      setFormData((prev) => ({ ...prev, boundary_wall_cost: "" }));
    }
  }, [formData.boundary_wall, formData.boundary_wall_repair]);

  useEffect(() => {
    if (formData.functional_latrines_repair !== "Yes") {
      setFormData((prev) => ({
        ...prev,
        // functional_latrines_repair_cost: ""
      }));
    }
  }, [formData.functional_latrines_repair]);

  useEffect(() => {
    if (formData.nonfunctional_latrines_repair !== "Yes") {
      setFormData((prev) => ({
        ...prev,
        // nonfunctional_latrines_repair_cost: ""
      }));
    }
  }, [formData.nonfunctional_latrines_repair]);

  useEffect(() => {
    if (formData.handwashing_station !== "Yes") {
      setFormData((prev) => ({
        ...prev,
        // handwashing_station_total: "",
        // handwashing_station_repair: "",
        // handwashing_station_repair_cost: ""
      }));
    } else if (formData.handwashing_station_repair !== "Yes") {
      setFormData((prev) => ({ ...prev, handwashing_station_repair_cost: "" }));
    }
  }, [formData.handwashing_station, formData.handwashing_station_repair]);

  useEffect(() => {
    if (formData.waste_disposal !== "Yes") {
      setFormData((prev) => ({
        ...prev,
        //  waste_disposal_area: ""
      }));
    }
  }, [formData.waste_disposal]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when field is updated
    clearFieldErrors(field);
  };

  const clearFieldErrors = (...fields) => {
    if (fields.some((field) => errors[field])) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        fields.forEach((field) => delete newErrors[field]);
        return newErrors;
      });
    }
  };
  const handleHandwashingChange = (field, value) => {
    let val = value.replace(/\D/g, "");
    if (val.length > 3) val = val.slice(0, 3);
    if (parseInt(val, 10) > 150) val = "150";

    setFormData((prev) => ({
      ...prev,
      [field]: val,
    }));
    clearFieldErrors(field);
  };

  const handleLatrineChange = (field, value) => {
    let val = value.replace(/\D/g, "");

    // Limit to 2 digits for all latrine fields
    if (val.length > 2) val = val.slice(0, 2);
    if (parseInt(val, 10) > 99) val = "99";

    setFormData((prev) => {
      const updated = { ...prev, [field]: val };

      // Handle functional latrines calculation
      if (
        field === "functional_latrines_male" ||
        field === "functional_latrines_female"
      ) {
        const male = parseInt(updated.functional_latrines_male) || 0;
        const female = parseInt(updated.functional_latrines_female) || 0;
        let total = male + female;
        if (total > 99) total = 99;
        updated.functional_latrines_total = total.toString();
      }

      // Handle non-functional latrines calculation
      if (
        field === "nonfunctional_latrines_male" ||
        field === "nonfunctional_latrines_female"
      ) {
        const male = parseInt(updated.nonfunctional_latrines_male) || 0;
        const female = parseInt(updated.nonfunctional_latrines_female) || 0;
        let total = male + female;
        if (total > 99) total = 99;
        updated.nonfunctional_latrines_total = total.toString();
      }

      return updated;
    });
    clearFieldErrors(
      field,
      field.startsWith("nonfunctional_")
        ? "nonfunctional_latrines_total"
        : "functional_latrines_total"
    );
  };

  const handleNumericChange = (field, value) => {
    // For functional_latrines_total, limit to 2 digits; for others, 7 digits

    const maxDigits = field === "functional_latrines_total" ? 2 : 7;
    const regex = new RegExp(`^\\d{0,${maxDigits}}$`);

    if (value === "" || regex.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));

      // Clear error when field is updated
      if (errors[field]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[field];
          return newErrors;
        });
      }
    }
  };
  const handleThreeDigitNumericChange = (field, value) => {
    let val = value.replace(/\D/g, "");
    if (val.length > 3) val = val.slice(0, 3);
    if (parseInt(val, 10) > 500) val = "500";
    setFormData((prev) => ({
      ...prev,
      [field]: val,
    }));
    clearFieldErrors(field);
  };

  // 🔹 Handle update button
  const handleUpdate = async () => {
    setIsUpdating(true);
    setErrors({});

    try {
      // Validate the form data
      await validationSchema.validate(formData, { abortEarly: false });

      // Prepare the update payload
      const updatePayload = {
        building_condition: formData.building_condition,
        repair_cost_estimate: formData.repair_cost_estimate || null,
        boundary_wall: formData.boundary_wall === "Yes",
        boundary_repair_needed: formData.boundary_wall_repair === "Yes",
        boundary_repair_cost: formData.boundary_wall_cost || null,
        health_building_structure: formData.structure_type,
        total_number_of_rooms: parseInt(formData.total_rooms) || 0,
        number_of_consulting_rooms: parseInt(formData.consulting_rooms) || 0,
        number_of_wards_rooms: parseInt(formData.wards) || 0,
        number_of_delivery_rooms: parseInt(formData.delivery_room) || 0,
        number_of_beds: parseInt(formData.beds_total) || 0,
        power_supply: Array.isArray(formData.power_supply) 
        ? formData.power_supply.join(',') 
        : formData.power_supply,
        water_source: formData.water_source,
        functional_latrines_total:
          parseInt(formData.functional_latrines_total) || 0,
        functional_latrines_male:
          parseInt(formData.functional_latrines_male) || 0,
        functional_latrines_female:
          parseInt(formData.functional_latrines_female) || 0,
        functional_latrines_repair:
          formData.functional_latrines_repair === "Yes",
        functional_repair_cost:
          formData.functional_latrines_repair_cost || null,
        non_functional_latrines_total:
          parseInt(formData.nonfunctional_latrines_total) || 0,
        non_functional_latrines_male:
          parseInt(formData.nonfunctional_latrines_male) || 0,
        non_functional_latrines_female:
          parseInt(formData.nonfunctional_latrines_female) || 0,
        non_functional_latrines_repair:
          formData.nonfunctional_latrines_repair === "Yes",
        non_functional_repair_cost:
          formData.nonfunctional_latrines_repair_cost || null,
        handwashing_stations_available: formData.handwashing_station === "Yes",
        handwashing_stations_count:
          parseInt(formData.handwashing_station_total) || 0,
        handwashing_repairable: formData.handwashing_station_repair === "Yes",
        handwashing_repair_cost:
          formData.handwashing_station_repair_cost || null,
        medical_waste_disposal: formData.waste_disposal === "Yes",
        waste_disposal_location: formData.waste_disposal_area || "",
        water_storage_type: formData.water_storage_type,
        specify_other_storage:
          formData.water_storage_type === "Others"
            ? formData.specify_other_storage
            : "",
        year_round_water_availability: formData.year_round_water_availability,
        handwash_stations_status: formData.handwash_stations_status,
        waste_disposal_location: formData.waste_disposal_area || "",
      };

      // Call the API with the correct endpoint and data format
      const response = await fetchData(
        `health-facility-update/${healthInfrastructure.health_facility_id}`,
        "PUT",
        { health_infrastructure: updatePayload },
        { "Content-Type": "application/json" }
      );


      if (response && response.success) {
        toast.success("Infrastructure & Environment updated successfully!");
        if (onUpdate) onUpdate(updatePayload);
      } else {
        toast.error(
          response?.message || "Failed to update Infrastructure & Environment"
        );
      }
    } catch (error) {
      if (error.inner) {
        // Validation errors
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
          console.error(`Validation Error: ${err.path} - ${err.message}`);
        });
        setErrors(newErrors);
      } else {
        // API or other errors
        console.error("Update error:", error);
        toast.error(error.message || "Update failed. Please try again.");
      }
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        {isDqaApproved2 && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Infrastructure And Physical Environment
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              General Infrastructure And Physical Environment
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        {isDqaApproved && (
          <span className="bg-green-100 text-green-700 px-3 py-1 rounded text-sm font-medium">
            Approved from DQA
          </span>
        )}
      </div>

      {/* Form Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Building Condition */}
        <div>
          <ThinDropdownWithSearch
            label="Building Condition "
            options={buildingConditions}
            value={formData.building_condition}
            onChange={(val) => handleChange("building_condition", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.building_condition && (
            <p className="text-red-500 text-xs">{errors.building_condition}</p>
          )}
        </div>

        {formData.building_condition === "Requires Minor Repairs" && (
          <div>
            <ThinTextField
              label="If requires repairs, estimated cost "
              type="number"
              value={formData.repair_cost_estimate}
              onChange={(e) =>
                handleNumericChange("repair_cost_estimate", e.target.value)
              }
              disabled={isDqaApproved || isDqaRejected}
            />
            {errors.repair_cost_estimate && (
              <p className="text-red-500 text-xs">
                {errors.repair_cost_estimate}
              </p>
            )}
          </div>
        )}

        {/* Boundary Wall */}
        <div>
          <ThinDropdownWithSearch
            label="Boundary Wall "
            options={yesNo}
            value={formData.boundary_wall}
            onChange={(val) => handleChange("boundary_wall", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.boundary_wall && (
            <p className="text-red-500 text-xs">{errors.boundary_wall}</p>
          )}
        </div>

        {formData.boundary_wall === "Yes" && (
          <>
            <div>
              <ThinDropdownWithSearch
                label="Boundary Wall Need of Repair "
                options={yesNo}
                value={formData.boundary_wall_repair}
                onChange={(val) => handleChange("boundary_wall_repair", val)}
                disabled={isDqaApproved || isDqaRejected}
              />
              {errors.boundary_wall_repair && (
                <p className="text-red-500 text-xs">
                  {errors.boundary_wall_repair}
                </p>
              )}
            </div>

            {formData.boundary_wall_repair === "Yes" && (
              <div>
                <ThinTextField
                  label=" Boundary Wall Estimated Repair Cost "
                  type="number"
                  value={formData.boundary_wall_cost}
                  onChange={(e) =>
                    handleNumericChange("boundary_wall_cost", e.target.value)
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
                {errors.boundary_wall_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.boundary_wall_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Structure Type */}
        <div>
          <ThinDropdownWithSearch
            label="Structure Type "
            options={structureTypes}
            value={formData.structure_type}
            onChange={(val) => handleChange("structure_type", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.structure_type && (
            <p className="text-red-500 text-xs">{errors.structure_type}</p>
          )}
        </div>

        {/* Rooms */}
        <div>
          <ThinTextField
            label="Total No. of Rooms"
            type="number"
            value={formData.total_rooms}
            onChange={(e) =>
              handleThreeDigitNumericChange("total_rooms", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.total_rooms && (
            <p className="text-red-500 text-xs">{errors.total_rooms}</p>
          )}
        </div>

        <div>
          <ThinTextField
            label="Consulting Rooms"
            type="number"
            value={formData.consulting_rooms}
            onChange={(e) =>
              handleThreeDigitNumericChange("consulting_rooms", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
        </div>

        <div>
          <ThinTextField
            label="Wards"
            type="number"
            value={formData.wards}
            onChange={(e) =>
              handleThreeDigitNumericChange("wards", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
        </div>

        <div>
          <ThinTextField
            label="Delivery Room"
            type="number"
            value={formData.delivery_room}
            onChange={(e) =>
              handleThreeDigitNumericChange("delivery_room", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />

          {errors.delivery_room && (
            <p className="text-red-500 text-xs">{errors.delivery_room}</p>
          )}
        </div>

        {/* Beds */}
        <div>
          <ThinTextField
            label="Number of Beds (Total)"
            type="number"
            value={formData.beds_total}
            onChange={(e) =>
              handleThreeDigitNumericChange("beds_total", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
        </div>

        {/* Power Supply */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Power Supply
          </label>
          <Select disabled={isDqaApproved || isDqaRejected}
            isMulti
            options={powerSupplies}
            value={powerSupplies.filter((option) =>
              formData.power_supply?.includes(option.value)
            )}
            onChange={(selected) =>
              handleChange(
                "power_supply",
                selected ? selected.map((item) => item.value) : []
              )
            }
            placeholder="Select Power Supply Options..."
            className="basic-multi-select"
            classNamePrefix="select"
            isDisabled={isDqaApproved}
          />
          {errors.power_supply && (
            <p className="text-red-500 text-xs">{errors.power_supply}</p>
          )}
        </div>
        {/* Water Source */}
        <div>
          <ThinDropdownWithSearch
            label="Water Source "
            options={waterSources}
            value={formData.water_source}
            onChange={(val) => handleChange("water_source", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.water_source && (
            <p className="text-red-500 text-xs">{errors.water_source}</p>
          )}
        </div>
        {/* Water Storage Type */}
        <div>
          <ThinDropdownWithSearch
            label="Water Storage Type"
            options={[
              { label: "Water Tank", value: "Water Tank" },
              { label: "Plastic Drum/tank", value: "Plastic Drum/tank" },
              { label: "No any", value: "No any" },
              { label: "Others", value: "Others" },
            ]}
            value={formData.water_storage_type}
            onChange={(val) => handleChange("water_storage_type", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.water_storage_type && (
            <p className="text-red-500 text-xs">{errors.water_storage_type}</p>
          )}
        </div>

        {/* Specify Other Storage → sirf jab Others selected ho */}
        {formData.water_storage_type === "Others" && (
          <div>
            <ThinTextField
              label="Specify Other Storage"
              value={formData.specify_other_storage}
              onChange={(e) =>
                handleChange("specify_other_storage", e.target.value)
              }
              disabled={isDqaApproved || isDqaRejected}
            />
            {errors.specify_other_storage && (
              <p className="text-red-500 text-xs">
                {errors.specify_other_storage}
              </p>
            )}
          </div>
        )}

        {/* Year Round Water Availability */}
        <div>
          <ThinDropdownWithSearch
            label="Year Round Water Availability"
            options={yesNo}
            value={formData.year_round_water_availability}
            onChange={(val) =>
              handleChange("year_round_water_availability", val)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.year_round_water_availability && (
            <p className="text-red-500 text-xs">
              {errors.year_round_water_availability}
            </p>
          )}
        </div>
        <div>
          <ThinTextField
            label="Functional Latrines (Male)"
            type="number"
            value={formData.functional_latrines_male}
            onChange={(e) =>
              handleLatrineChange("functional_latrines_male", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.functional_latrines_male && (
            <p className="text-red-500 text-xs">
              {errors.functional_latrines_male}
            </p>
          )}
        </div>

        <div>
          <ThinTextField
            label="Functional Latrines (Female)"
            type="number"
            value={formData.functional_latrines_female}
            onChange={(e) =>
              handleLatrineChange("functional_latrines_female", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.functional_latrines_female && (
            <p className="text-red-500 text-xs">
              {errors.functional_latrines_female}
            </p>
          )}
        </div>

        <div>
          <ThinTextField
            label="Functional Latrines (Total)"
            type="number"
            value={formData.functional_latrines_total}
            disabled={true}
          />
          {errors.functional_latrines_total && (
            <p className="text-red-500 text-xs">
              {errors.functional_latrines_total}
            </p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch
            label=" Need of Repair Functional Latrines "
            options={yesNo}
            value={formData.functional_latrines_repair}
            onChange={(val) => handleChange("functional_latrines_repair", val)}
            disabled={isDqaApproved || isDqaRejected}
            required
          />
          {errors.functional_latrines_repair && (
            <p className="text-red-500 text-xs">
              {errors.functional_latrines_repair}
            </p>
          )}
        </div>
        {formData.functional_latrines_repair === "Yes" && (
          <div>
            <ThinTextField
              label="Functional Latrines Estimated Repair Cost "
              type="number"
              value={formData.functional_latrines_repair_cost}
              onChange={(e) =>
                handleNumericChange(
                  "functional_latrines_repair_cost",
                  e.target.value
                )
              }
              disabled={isDqaApproved || isDqaRejected}
            />
            {errors.functional_latrines_repair_cost && (
              <p className="text-red-500 text-xs">
                {errors.functional_latrines_repair_cost}
              </p>
            )}
          </div>
        )}
        {/* Non-Functional Latrines Male */}
        <div>
          <ThinTextField
            label="Non-Functional Latrines (Male)"
            type="number"
            value={formData.nonfunctional_latrines_male}
            onChange={(e) =>
              handleLatrineChange("nonfunctional_latrines_male", e.target.value)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.nonfunctional_latrines_male && (
            <p className="text-red-500 text-xs">
              {errors.nonfunctional_latrines_male}
            </p>
          )}
        </div>

        {/* Non-Functional Latrines Female */}
        <div>
          <ThinTextField
            label="Non-Functional Latrines (Female)"
            type="number"
            value={formData.nonfunctional_latrines_female}
            onChange={(e) =>
              handleLatrineChange(
                "nonfunctional_latrines_female",
                e.target.value
              )
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.nonfunctional_latrines_female && (
            <p className="text-red-500 text-xs">
              {errors.nonfunctional_latrines_female}
            </p>
          )}
        </div>
        {/* Non-Functional Latrines Total */}
        <div>
          <ThinTextField
            label="Non-Functional Latrines (Total)"
            type="number"
            value={formData.nonfunctional_latrines_total}
            onChange={(e) =>
              handleLatrineChange(
                "nonfunctional_latrines_total",
                e.target.value
              )
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.nonfunctional_latrines_total && (
            <p className="text-red-500 text-xs">
              {errors.nonfunctional_latrines_total}
            </p>
          )}
        </div>
        <div>
          <ThinDropdownWithSearch
            label="Need of Repair (Non-Functional Latrines)"
            options={yesNo}
            value={formData.nonfunctional_latrines_repair}
            onChange={(val) =>
              handleChange("nonfunctional_latrines_repair", val)
            }
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.nonfunctional_latrines_repair && (
            <p className="text-red-500 text-xs">
              {errors.nonfunctional_latrines_repair}
            </p>
          )}
        </div>
        {formData.nonfunctional_latrines_repair === "Yes" && (
          <div>
            <ThinTextField
              label=" Non-Functional Latrines Estimated Repair Cost "
              type="number"
              value={formData.nonfunctional_latrines_repair_cost}
              onChange={(e) =>
                handleNumericChange(
                  "nonfunctional_latrines_repair_cost",
                  e.target.value
                )
              }
              disabled={isDqaApproved || isDqaRejected}
            />
            {errors.nonfunctional_latrines_repair_cost && (
              <p className="text-red-500 text-xs">
                {errors.nonfunctional_latrines_repair_cost}
              </p>
            )}
          </div>
        )}

        {/* Handwash Stations Status */}
        <div>
          <ThinDropdownWithSearch
            label="Handwash Stations Status"
            options={[
              { label: "Functional", value: "Functional" },
              { label: "Non-Functional", value: "Non-Functional" },
              { label: "Needs Repair", value: "Needs Repair" },
            ]}
            value={formData.handwash_stations_status}
            onChange={(val) => handleChange("handwash_stations_status", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.handwash_stations_status && (
            <p className="text-red-500 text-xs">
              {errors.handwash_stations_status}
            </p>
          )}
        </div>
        {/* Handwashing Stations */}
        <div>
          <ThinDropdownWithSearch
            label="Handwashing Stations "
            options={yesNo}
            value={formData.handwashing_station}
            onChange={(val) => handleChange("handwashing_station", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.handwashing_station && (
            <p className="text-red-500 text-xs">{errors.handwashing_station}</p>
          )}
        </div>

        {formData.handwashing_station === "Yes" && (
          <>
            <div>
              <ThinTextField
                label="Handwashing Stations Total"
                type="text"
                value={formData.handwashing_station_total}
                onChange={(e) =>
                  handleHandwashingChange(
                    "handwashing_station_total",
                    e.target.value
                  )
                }
                disabled={isDqaApproved || isDqaRejected}
              />
              {errors.handwashing_station_total && (
                <p className="text-red-500 text-xs">
                  {errors.handwashing_station_total}
                </p>
              )}
            </div>

            <div>
              <ThinDropdownWithSearch
                label="Handwashing Stations Repairable "
                options={yesNo}
                value={formData.handwashing_station_repair}
                onChange={(val) =>
                  handleChange("handwashing_station_repair", val)
                }
                disabled={isDqaApproved || isDqaRejected}
              />
              {errors.handwashing_station_repair && (
                <p className="text-red-500 text-xs">
                  {errors.handwashing_station_repair}
                </p>
              )}
            </div>

            {formData.handwashing_station_repair === "Yes" && (
              <div>
                <ThinTextField
                  label="Handwashing Stations Estimated Repair Cost "
                  type="number"
                  value={formData.handwashing_station_repair_cost}
                  onChange={(e) =>
                    handleNumericChange(
                      "handwashing_station_repair_cost",
                      e.target.value
                    )
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
                {errors.handwashing_station_repair_cost && (
                  <p className="text-red-500 text-xs">
                    {errors.handwashing_station_repair_cost}
                  </p>
                )}
              </div>
            )}
          </>
        )}

        {/* Medical Waste Disposal */}
        {/* <div>
          <ThinDropdownWithSearch
            label="Medical Waste Disposal "
            options={yesNo}
            value={formData.waste_disposal}
            onChange={(val) => handleChange("waste_disposal", val)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.waste_disposal && <p className="text-red-500 text-xs">{errors.waste_disposal}</p>}
        </div> */}

        {/* {formData.waste_disposal === "Yes" && (
          <div>
          <ThinTextField
            label="Dispose-off place/area "
            value={formData.waste_disposal_area}
            onChange={(e) => handleChange("waste_disposal_area", e.target.value)}
            disabled={isDqaApproved || isDqaRejected}
          />
          {errors.waste_disposal_area && <p className="text-red-500 text-xs">{errors.waste_disposal_area}</p>}
        </div>
        )} */}
      </div>

      {/*Update Button */}
      {!isDqaApproved2 && !isDqaRejected ? (
        <div className="mt-8 flex justify-end">
          <button
            type="button"
            onClick={handleUpdate}
            disabled={isUpdating}
            className={`${
              isUpdating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-teal-600 hover:bg-teal-700"
            } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
          >
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </div>
      ) : (
        <div className=""></div>
      )}
    </>
  );
};

export default InfrastructureEnvironment;
